export default "__VITE_ASSET__DcsdMKka__"